module.exports = __webpack_public_path__ + "img/thumbnail_CuviersDwarfCaiman_j_albino.919c9b26.png";